import { useEffect, useState } from "react";
import {
  CombinedWarehouseOrderItemDto,
  WarehouseOrderItemGroupingDto,
} from "@lib/ShiOneClient";
import { FilterByState } from "../../helpers/WarehouseOrdersHelpers";

export interface TrackingItems {
  deliveryMethod: string;
  trackNum: string;
  shipDate: Date;
  items: WarehouseOrderItemGroupingDto[];
  trackUrl: string;
}
export default function useGetWarehouseTracking(
  orderItem: CombinedWarehouseOrderItemDto | undefined
) {
  const [itemsBeingWorkedOn, setItemsBeingWorkedOn] = useState<
    TrackingItems | undefined
  >();
  const [orderedItems, setOrderedItems] = useState<
    TrackingItems[] | undefined
  >();
  const [pickedItems, setPickedItems] = useState<TrackingItems[] | undefined>();
  const [shippedItems, setShippedItems] = useState<
    TrackingItems[] | undefined
  >();
  const [trackingNumbers, setTrackingNumbers] = useState<TrackingItems[]>([]);

  useEffect(() => {
    if (!orderItem) return;

    let trackingNums: any[] = [];
    orderItem.deliveryInfo?.forEach((delivery) => {
      trackingNums = [
        ...trackingNums,
        {
          deliveryMethod: delivery?.deliveryMethod ?? undefined,
          trackNum: delivery?.trackNum ?? "",
          shipDate: delivery?.shipDate ?? undefined,
          items: orderItem.items?.filter(
            (item) =>
              item.trackNum === (delivery.trackNum ? delivery.trackNum : "")
          ),
          trackUrl: delivery?.trackUrl ?? "",
        },
      ];
    });
    setTrackingNumbers(trackingNums);
  }, [orderItem]);

  useEffect(() => {
    if (!trackingNumbers) return;

    setOrderedItems(FilterByState("Ordered", trackingNumbers));
    setPickedItems(FilterByState("Picked", trackingNumbers));
    setShippedItems(FilterByState("Shipped", trackingNumbers));
    //verify items being worked on works how intended
    setItemsBeingWorkedOn(
      trackingNumbers?.find((item) => item.trackNum === "")
    );
  }, [trackingNumbers]);

  return {
    trackingNumbers,
    itemsBeingWorkedOn,
    orderedItems,
    pickedItems,
    shippedItems,
  };
}
